import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { WidgetHelper } from '../WidgetHelper';
import { Dictionary } from '../../Models';
import { SubscribeEventFormWidget } from '.';
import { IEventOtherDate } from '../../Models/Event/IEventOtherDate';

interface ISubscribeEventProps {
    dictSubscribe: string;
    id: string;
    isNissRequired: string;
    dictFirstName: string;
    dictLastName: string;
    dictEmail: string;
    dictPhone: string;
    dictLanguage: string;
    dictSend: string;
    dictErrorSubscribe: string;
    dictSuccessSubscribe: string;
    dictAlreadySubscribe: string;
    dictClose: string;
    dictDate: string;
    subscribeCount: string;
    maxSubscribe: string;
    dictNiss: string;
    dictEventFull: string;
    dictEventFullSubscribers: string;
    dictEventInThePast: string;
    dictMaxDateSubscribeInThePast: string;
    dictNotFirstnameFill: string;
    dictNotLastnameFill: string;
    dictNotEmailFill: string;
    dictNotLanguageFill: string;
    dictNotNissFill: string;
    dictGdrpSentences: string;
    dictGdrpLink: string;
    dictLiveInBrussels: string;
    dictActirisSubscribe: string;
    dictNotActirisSubscribe: string;
    linkGdpr: string;
    dictNoGdprFill: string;
    dictNotPhoneFill: string;
    category: string;
    dictEventSubscribeClose: string;
    otherDates: string;
    startDate: string;
    maxSubscribeDate: string;
    endDate: string;
    showSubscribeButton: string;
}

interface ISubscribeEventWidgetState {
    showModalSubscribe: boolean;
    isNissRequired: boolean;
    otherDates: IEventOtherDate[];
}

export class SubscribeEventWidget extends Component<
    ISubscribeEventProps,
    ISubscribeEventWidgetState
> {
    selectedLanguage: Dictionary<number, string>;

    constructor(props: any) {
        super(props);

        const parsedOtherDates = JSON.parse(
            this.props.otherDates
        ) as IEventOtherDate[];

        this.state = {
            showModalSubscribe: false,
            isNissRequired: this.props.isNissRequired === 'True',
            otherDates:
                parsedOtherDates.length > 0
                    ? [
                          {
                              EventId: parseInt(this.props.id),
                              StartDate: new Date(this.props.startDate),
                              MaxDateSubscribe: new Date(
                                  this.props.maxSubscribeDate
                              ),
                              EndDate: new Date(this.props.endDate),
                              NbrRegistered: parseInt(
                                  this.props.subscribeCount
                              ),
                              Places: parseInt(this.props.maxSubscribe),
                          } as IEventOtherDate,
                      ].concat(
                          (
                              JSON.parse(
                                  this.props.otherDates
                              ) as IEventOtherDate[]
                          ).map((oD: IEventOtherDate) => ({
                              ...oD,
                              StartDate: this.recreateDate(
                                  oD.StartDate as string
                              ),
                              EndDate: this.recreateDate(oD.EndDate as string),
                              MaxDateSubscribe: this.recreateDate(
                                  oD.MaxDateSubscribe as string
                              ),
                          }))
                      )
                    : [],
        };
    }

    recreateDate(dateString: string): Date {
        return new Date(parseInt(dateString.replace(/[/Date(]|\)/g, '')));
    }

    handleOpenModalSubscribe = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        this.setState({ showModalSubscribe: true });
    };

    handleCloseModalSubscribe = () => {
        this.setState({ showModalSubscribe: false });
    };

    render() {
        let SubscribeButton: JSX.Element;
        const showSubscribeButtonBool = /true/i.test(
            this.props.showSubscribeButton
        );
        if (showSubscribeButtonBool) {
            if (
                +this.props.subscribeCount < +this.props.maxSubscribe &&
                ((this.state.otherDates && this.state.otherDates.length > 0) ||
                    new Date(this.props.maxSubscribeDate) > new Date())
            ) {
                SubscribeButton = (
                    <a
                        className="btn-primary btn-full"
                        href=""
                        onClick={this.handleOpenModalSubscribe}
                    >
                        {this.props.dictSubscribe}
                    </a>
                );
            } else {
                SubscribeButton = (
                    <a className="disabled btn-primary btn-full">
                        {this.props.dictSubscribe}
                    </a>
                );
            }
        } else {
            SubscribeButton = <></>;
        }

        return (
            <>
                {SubscribeButton}

                <ReactModal
                    isOpen={this.state.showModalSubscribe}
                    className="modal__dialog modal__dialog--sized"
                    overlayClassName="modal__backdrop"
                    onRequestClose={this.handleCloseModalSubscribe}
                    closeTimeoutMS={200}
                    ariaHideApp={false}
                    bodyOpenClassName="dialog--open"
                >
                    <button
                        className="modal__close btn-no-look"
                        onClick={this.handleCloseModalSubscribe}
                    >
                        <i className="icon-cross"></i>
                        <span className="sr-only">Fermer</span>
                    </button>

                    <SubscribeEventFormWidget
                        dictAlreadySubscribe={this.props.dictAlreadySubscribe}
                        dictClose={this.props.dictClose}
                        dictEmail={this.props.dictEmail}
                        dictDate={this.props.dictDate}
                        dictErrorSubscribe={this.props.dictErrorSubscribe}
                        dictFirstName={this.props.dictFirstName}
                        dictLanguage={this.props.dictLanguage}
                        dictLastName={this.props.dictLastName}
                        dictPhone={this.props.dictPhone}
                        dictSend={this.props.dictSend}
                        dictSubscribe={this.props.dictSubscribe}
                        dictSuccessSubscribe={this.props.dictSuccessSubscribe}
                        id={this.props.id}
                        handleCloseModalSubscribe={
                            this.handleCloseModalSubscribe
                        }
                        dictNiss={this.props.dictNiss}
                        dictNotEmailFill={this.props.dictNotEmailFill}
                        dictNotFirstnameFill={this.props.dictNotFirstnameFill}
                        dictNotLanguageFill={this.props.dictNotLanguageFill}
                        dictNotLastnameFill={this.props.dictNotLastnameFill}
                        dictNotNissFill={this.props.dictNotNissFill}
                        dictGdrpLink={this.props.dictGdrpLink}
                        dictGdrpSentences={this.props.dictGdrpSentences}
                        dictNoGdprFill={this.props.dictNoGdprFill}
                        dictActirisSubscribe={this.props.dictActirisSubscribe}
                        dictNotActirisSubscribe={
                            this.props.dictNotActirisSubscribe
                        }
                        dictLiveInBrussels={this.props.dictLiveInBrussels}
                        linkGdpr={this.props.linkGdpr}
                        dictNotPhoneFill={this.props.dictNotPhoneFill}
                        category={this.props.category}
                        dictEventSubscribeClose={
                            this.props.dictEventSubscribeClose
                        }
                        dictEventFull={this.props.dictEventFull}
                        dictEventFullSubscribers={
                            this.props.dictEventFullSubscribers
                        }
                        dictEventInThePast={this.props.dictEventInThePast}
                        dictMaxDateSubscribeInThePast={
                            this.props.dictMaxDateSubscribeInThePast
                        }
                        isNissRequired={this.state.isNissRequired}
                        otherDates={this.state.otherDates}
                    ></SubscribeEventFormWidget>
                </ReactModal>
            </>
        );
    }
}

WidgetHelper.register(SubscribeEventWidget, 'subscribe-event-widget');
